module.exports = __webpack_public_path__ + "img/logo.805803c0.png";